import { ISidebarContentComponent } from "./sidebar";

export * from "../../../core/services/global/sidebar/sidebar.service";
export * from "./components";

export type SidebarContentComponent<Options> = ISidebarContentComponent<Options>;
